var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovaWalletStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0H105C127.091 0 145 17.9086 145 40V105C145 127.091 127.091 145 105 145H40C17.9086 145 0 127.091 0 105V40Z",
    fill: "url(#paint0_linear_1014_14373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.515 24.6219C71.7083 23.5186 73.2917 23.5186 73.485 24.6219L79.265 57.6109C79.9918 61.7596 83.2404 65.0082 87.3891 65.7351L120.378 71.515C121.481 71.7083 121.481 73.2917 120.378 73.485L87.3891 79.265C83.2404 79.9918 79.9918 83.2404 79.265 87.3891L73.485 120.378C73.2917 121.481 71.7083 121.481 71.515 120.378L65.7351 87.3891C65.0082 83.2404 61.7596 79.9918 57.6109 79.265L24.6219 73.485C23.5186 73.2917 23.5186 71.7083 24.6219 71.515L57.6109 65.7351C61.7596 65.0082 65.0082 61.7596 65.7351 57.6109L71.515 24.6219Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1014_14373",
    x1: 138.302,
    y1: -63.9403,
    x2: -0.0000111118,
    y2: 205.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#541E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47142,
    stopColor: "#3F51D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609119,
    stopColor: "#73AFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801091,
    stopColor: "#90D7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaWalletStar);
export default __webpack_public_path__ + "static/media/nova-wallet-star.3dc5a8c7f307338208288508dc00fde8.svg";
export { ForwardRef as ReactComponent };